import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { NotificationActions } from "../../store/actions";
import { AppNotifications } from "../../models";

const useNoti = () => {
  const dispatch = useDispatch();

  const actions = bindActionCreators(Object.assign(NotificationActions), dispatch);

  const pushNoti = (notiType: "error" | "success" | "warning" | "info", message: string): void => {
    let type = "";
    switch(notiType) {
      case "error":
        type = AppNotifications.ERROR;
        break;
      case "success":
        type = AppNotifications.SUCCESS;
        break;
      case "warning":
        type = AppNotifications.WARNING;
        break;
      case "info":
        type = AppNotifications.INFO;
        break;
      default:
        type = AppNotifications.ERROR;
        break;
    }
    actions.enqueueSnackbar({
      type,
      message
    });
  }

  return [pushNoti] as const;
}

export default useNoti;
